module.exports = __webpack_public_path__ + "static/media/cPanel.d6a6ebf1.png";